import { useEffect, useRef, useState } from "react";

const STATS = [
  { end: 4891,   label: "WOs closed",         prefix: "" ,   suffix: "" },
  { end: 187000, label: "Vendor bills reconciled", prefix: "$", suffix: "" },
  { end: 26,     label: "Cameras tracked",    prefix: "",    suffix: "" },
  { end: 12,     label: "Hrs saved / admin / week", prefix: "", suffix: "" },
];

const fmt = (n, prefix, suffix) => {
  const rounded = Math.round(n);
  if (rounded >= 1000) {
    return `${prefix}${(rounded / 1000).toFixed(rounded % 1000 === 0 ? 0 : 1)}k${suffix}`;
  }
  return `${prefix}${rounded}${suffix}`;
};

/** Animated hero counters. Ticks from 0 to target on first scroll into view. */
export default function NumbersThatRoll() {
  const ref = useRef(null);
  const [triggered, setTriggered] = useState(false);
  const [values, setValues] = useState(STATS.map(() => 0));

  useEffect(() => {
    if (triggered) return;
    const io = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) setTriggered(true);
    }, { threshold: 0.25 });
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, [triggered]);

  useEffect(() => {
    if (!triggered) return;
    const startedAt = performance.now();
    const dur = 1600;
    let raf;
    const step = (t) => {
      const p = Math.min(1, (t - startedAt) / dur);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - p, 3);
      setValues(STATS.map(s => s.end * eased));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [triggered]);

  return (
    <section ref={ref} className="py-16 sm:py-20 bg-[#0b1220] text-white" data-testid="landing-numbers">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="text-xs font-black uppercase tracking-widest mb-3 text-teal-300">Radar in Motion</div>
          <h2 className="font-display font-black text-3xl sm:text-4xl leading-tight tracking-tight">
            Numbers that actually move the needle
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {STATS.map((s, i) => (
            <div key={i} data-testid={`stat-${i}`}
              className="p-5 border-2 border-slate-700 bg-[#111a2e] text-center hover:border-teal-400 transition-colors">
              <div className="font-display font-black text-4xl sm:text-5xl tabular-nums text-teal-300 leading-none">
                {fmt(values[i], s.prefix, s.suffix)}
              </div>
              <div className="mt-2 text-xs font-black uppercase tracking-widest text-slate-400">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
